import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { useLanguage } from "../context/LanguageContext";
import { useBookDemo } from "../context/BookDemoContext";

export function BookDemoModal() {
  const { t } = useLanguage();
  const { open, setOpen } = useBookDemo();
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "" });
  const [submitting, setSubmitting] = useState(false);
  const setField = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    // No booking backend wired yet -- this captures the request client-side and
    // hands off to the same email channel as the contact form until a scheduling
    // endpoint exists. Swap for a real POST once one is added.
    toast.success(t.bookDemo.toastTitle, { description: t.bookDemo.toastDesc });
    setForm({ name: "", company: "", email: "", phone: "" });
    setSubmitting(false);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md" data-testid="book-demo-modal">
        <DialogHeader>
          <DialogTitle className="font-heading font-medium">{t.bookDemo.title}</DialogTitle>
          <DialogDescription>{t.bookDemo.desc}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2 min-w-0">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-medium text-neutral-600 dark:text-neutral-400 uppercase tracking-wide">{t.bookDemo.nameLabel}</label>
              <input data-testid="book-demo-name-input" required value={form.name} onChange={setField("name")}
                className="mt-1.5 w-full bg-white dark:bg-neutral-900 border border-neutral-300 dark:border-neutral-700 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#111] dark:focus:ring-white" />
            </div>
            <div>
              <label className="text-xs font-medium text-neutral-600 dark:text-neutral-400 uppercase tracking-wide">{t.bookDemo.companyLabel}</label>
              <input data-testid="book-demo-company-input" required value={form.company} onChange={setField("company")}
                className="mt-1.5 w-full bg-white dark:bg-neutral-900 border border-neutral-300 dark:border-neutral-700 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#111] dark:focus:ring-white" />
            </div>
          </div>
          <div>
            <label className="text-xs font-medium text-neutral-600 dark:text-neutral-400 uppercase tracking-wide">{t.bookDemo.emailLabel}</label>
            <input data-testid="book-demo-email-input" type="email" required value={form.email} onChange={setField("email")}
              className="mt-1.5 w-full bg-white dark:bg-neutral-900 border border-neutral-300 dark:border-neutral-700 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#111] dark:focus:ring-white" />
          </div>
          <div>
            <label className="text-xs font-medium text-neutral-600 dark:text-neutral-400 uppercase tracking-wide">{t.bookDemo.phoneLabel}</label>
            <input data-testid="book-demo-phone-input" value={form.phone} onChange={setField("phone")}
              className="mt-1.5 w-full bg-white dark:bg-neutral-900 border border-neutral-300 dark:border-neutral-700 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#111] dark:focus:ring-white" />
          </div>
          <button type="submit" disabled={submitting} data-testid="book-demo-submit-button"
            className="w-full bg-[#111] dark:bg-white text-white dark:text-[#111] rounded-full py-3 text-sm font-medium hover:bg-neutral-800 dark:hover:bg-neutral-200 transition-colors disabled:opacity-50">
            {submitting ? t.bookDemo.submitting : t.bookDemo.submit}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
